import { type ComponentType, createElement, type ReactNode } from 'react';

/**
 * Hides or masks its children in FullStory session replays.
 * https://help.fullstory.com/hc/en-us/articles/360020623574
 */
type Privacy = 'mask' | 'exclude' | 'unmask';

interface FSPrivacyProps {
	privacy?: Privacy;
	children: ReactNode;
}

export const FSPrivacy = ({
	privacy = 'exclude',
	children,
}: FSPrivacyProps) => <div className={`fs-${privacy}`}>{children}</div>;

const applyPrivacy = <P extends object>(
	Component: ComponentType<P>,
	privacy: Privacy,
) => {
	const WithPrivacy = (props: P) => (
		<div className={`fs-${privacy}`}>{createElement(Component, props)}</div>
	);
	WithPrivacy.displayName = `FSPrivacy(${Component.displayName ?? Component.name ?? 'Component'})`;
	return WithPrivacy;
};

/** Wraps a component so its contents are masked (text replaced) in replays. */
export const applyMask = <P extends object>(Component: ComponentType<P>) =>
	applyPrivacy(Component, 'mask');

export default FSPrivacy;
